import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { SOLUTION_NAV_GROUPS } from '../constants/homeSections';
import './mega-menu/solutions-nav.css';

export default function SolutionsNavPanel({ onItemClick, variant = 'dropdown' }) {
  const { t } = useLanguage();
  const isMobile = variant === 'mobile';

  return (
    <div
      className={`solutions-nav${isMobile ? ' solutions-nav--mobile' : ''}`}
      role={isMobile ? undefined : 'menu'}
    >
      {SOLUTION_NAV_GROUPS.map((group, groupIndex) => (
        <section
          key={group.id}
          className={`solutions-nav__group${groupIndex > 0 ? ' solutions-nav__group--bordered' : ''}`}
        >
          <h3 className="solutions-nav__heading">{t(group.titleKey)}</h3>
          <div className="solutions-nav__grid">
            {group.items.map((item) => (
              <button
                key={item.id}
                type="button"
                role={isMobile ? undefined : 'menuitem'}
                onClick={() => onItemClick(item)}
                className="solutions-nav__item"
                data-testid={`${isMobile ? 'mobile-' : ''}nav-solution-${item.id}`}
              >
                <span className="solutions-nav__icon-wrap" aria-hidden>
                  <img
                    src={item.iconSrc}
                    alt=""
                    className="solutions-nav__icon"
                    width={48}
                    height={48}
                    loading="lazy"
                    decoding="async"
                  />
                </span>
                <span className="solutions-nav__label">{t(item.labelKey)}</span>
              </button>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
